module.exports = __webpack_public_path__ + "static/media/logo-dark.de9420be.png";